<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Location</label>
          <el-input type="text"
                 name="location"
                 placeholder="Location"
                 data-vv-as="location"
                 :clearable="true"
                 v-validate="modelValidations.location"
                 v-model="address.location" />
          <small class="text-danger" v-show="errors.has('location')">
            {{ getError('location') }}
          </small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Type</label>
          <el-select class="select"
                     size="large"
                     name="type"
                     clearable
                     data-vv-as="type"
                     placeholder="Type"
                     v-validate="modelValidations.type"
                     v-model="address.type">
            <el-option v-for="option in types"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label" />
          </el-select>
          <small class="text-danger" v-show="errors.has('type')">
            {{ getError('type') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>City</label>
          <el-autocomplete
            style="width:100%"
            name="city"
            class="inline-input"
            ref="city"
            :clearable="true"
            v-model="localCity"
            v-validate="modelValidations.city"
            :fetch-suggestions="findCities"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="City"
            @blur="verifyCityAutocompleteSelected"
            @select="setCityLoadCountiesZips">
          </el-autocomplete>
          <small class="text-danger" v-show="errors.has('city')">
            {{ getError('city') }}
          </small>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('city')">
            {{ fieldNotValidError('City') }}
          </small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>County</label>
          <el-select class="select"
                     size="large"
                     name="county"
                     placeholder="County"
                     @focus="verifyCitySelected"
                     v-model="address.county">
            <el-option v-for="option in counties"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="errors.has('county')">
            {{ getError('county') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>State</label>
          <el-select class="select"
                     size="large"
                     name="state"
                     data-vv-as="state"
                     placeholder="State"
                     clearable
                     v-validate="modelValidations.state"
                     v-model="address.state">
            <el-option v-for="option in states"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label" />
          </el-select>
          <small class="text-danger" v-show="errors.has('state')">
            {{ getError('state') }}
          </small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Zip</label>
          <el-select class="select"
                     name="zip"
                     size="large"
                     clearable
                     placeholder="Zip"
                     @focus="verifyCitySelected"
                     v-model="address.zip">
            <el-option v-for="option in zipCodes"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="errors.has('zip')">
            {{ getError('zip') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Country</label>
          <el-select class="select"
                     size="large"
                     name="country"
                     clearable
                     placeholder="Country"
                     v-model="address.country">
            <el-option v-for="option in countries"
                       class="select"
                       :value="option.value"
                       :label="option.label"
                       :key="option.label" />
          </el-select>
          <small class="text-danger" v-show="errors.has('country')">
            {{ getError('country') }}
          </small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>PO Box</label>
          <el-input type="text"
                 name="poBox"
                 placeholder="PO Box"
                 :clearable="true"
                 data-vv-as="PO box"
                 v-model="address.poBox" />
          <small class="text-danger" v-show="errors.has('poBox')">
            {{ getError('poBox') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Street Number</label>
          <el-input type="text"
                 name="streetNumber"
                 placeholder="Street Number"
                 data-vv-as="street number"
                 :clearable="true"
                 v-model="address.streetNumber" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Street Name</label>
          <el-autocomplete
            style="width:100%"
            ref="streetName"
            name="streetName"
            class="inline-input"
            :clearable="true"
            v-model="localStreetName"
            data-vv-as="street name"
            :fetch-suggestions="findStreets"
            :trigger-on-focus="false"
            value-key="name"
            placeholder="Street Name"
            @focus="verifyCitySelected"
            @blur="verifyStreetNameAutocompleteSelected"
            @select="setStreet">
          </el-autocomplete>
          <small class="text-danger" v-show="showInvalidAutocompleteWarning('streetName')">
            {{ fieldNotValidError('Street Name') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Suite Number</label>
          <el-input type="text"
                 name="suiteNumber"
                 placeholder="Suite Number"
                 data-vv-as="suite number"
                 :clearable="true"
                 v-model="address.suiteNumber" />
          <small class="text-danger" v-show="errors.has('suiteNumber')">
            {{ getError('suiteNumber') }}
          </small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Building Number</label>
          <el-input type="text"
                 name="buildingNumber"
                 placeholder="Building Number"
                 data-vv-as="building number"
                 :clearable="true"
                 v-model="address.buildingNumber" />
          <small class="text-danger" v-show="errors.has('buildingNumber')">
            {{ getError('buildingNumber') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row" v-if="canEdit">
      <div class="col-md-12">
        <button type="submit" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {ObjectID} from 'bson'
  import {
    findCities,
    findStreets,
    kvpsForSelectFromArray,
    notifyWarning,
    setCityLoadCountiesZips,
    autocompleteTextButNoValue,
    autocompleteTextButNoValueMessage,
    isAddOnTheFlyOrNoResultModalOpen
  } from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import {OK} from 'http-status-codes'
  import Permissions from 'src/utilities/permissions'
  import _ from 'lodash'

  export default {
    props: ['data'],
    computed: {
      ...mapGetters({
        activeModals: 'modalTracker/activeModals',
        types: 'types/address',
        states: 'states',
        countries: 'countries'
      }),
      canEdit() {
        return this.$can('edit', Permissions.COMPANIES)
      }
    },
    data () {
      return {
        localCity: null,
        localStreetName: null,
        counties: [],
        zipCodes: [],
        address: {
          id: null,
          location: null,
          type: null,
          streetNumber: null,
          suiteNumber: null,
          poBox: null,
          buildingNumber: null,
          floorNumber: null,
          streetName: null,
          city: null,
          county: null,
          state: Constants.ATS.DEFAULT.STATE,
          country: Constants.ATS.DEFAULT.COUNTRY,
          zip: null
        },
        modelValidations: {
          location: {
            required: false
          },
          type: {
            required: true
          },
          city: {
            required: true
          },
          state: {
            required: true
          }
        }
      }
    },
    methods: {
      verifyCityAutocompleteSelected() {
        if (this.localCity !== this.address.city) {
          this.resetDependentAutocompleteFields()

          if (isAddOnTheFlyOrNoResultModalOpen(this, 'city')) {
            return
          }
          setTimeout(() => {
            if (_.size(this.localCity) > 0 && this.address.city == null) {
              notifyWarning(this, Constants.MESSAGES.CITY_NOT_SELECTED)
            }
            this.$forceUpdate()
          }, Constants.TIME.MILLIS.THIRD_SECOND)
        }
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      showInvalidAutocompleteWarning(refAndPathName) {
        // $ref has to match local prop
        return autocompleteTextButNoValue(this, refAndPathName, this.address[refAndPathName])
      },
      fieldNotValidError(field) {
        return autocompleteTextButNoValueMessage(field)
      },
      async validateAndSubmit() {
        if (await this.$validator.validateAll()) {
          if (this.data) {
            this.$store.commit('companies/companyAddressUpdate', this.address)
          } else {
            this.address.id = new ObjectID()
            this.$store.commit('companies/companyAddressAdd', this.address)
          }
          this.$emit('close')
        }
      },
      async findCities(text, cb) {
        findCities(this, text, cb)
      },
      clearCity() {
        this.localCity = null
      },
      verifyCitySelected() {
        if (!this.address.city || !this.localCity) {
          this.$eventHub.$emit('show-modal-6', 'No City Error', null, '500px')
        }
      },
      setCityLoadCountiesZips(city) {
        setCityLoadCountiesZips(this, city)
        this.address.city = city.name
      },
      async findStreets(text, cb) {
        findStreets(this, text, cb)
      },
      clearStreet() {
        this.localStreetName = null
      },
      verifyStreetNameAutocompleteSelected() {
        if (isAddOnTheFlyOrNoResultModalOpen(this, 'street')) {
          return
        }

        setTimeout(() => {
          if (_.size(this.localStreetName) > 0 && this.address.streetName == null) {
            notifyWarning(this, Constants.MESSAGES.STREET_NAME_NOT_SELECTED)
          }
          this.$forceUpdate()
        }, Constants.TIME.MILLIS.THIRD_SECOND)
      },
      setStreet(street) {
        if (street) {
          this.address.streetName = street.name
          this.localStreetName = street.name
        }
      },
      resetDependentAutocompleteFields() {
        this.counties = []
        this.zipCodes = []
        this.localStreetName = null
        this.$store.set('address/cities', [])
        this.address.city = null
        this.address.streetName = null
        this.address.county = null
        this.address.zip = null
      }
    },
    beforeCreate() {
      this.$store.cache.dispatch('types/fetchByEntityType', 'Address')
    },
    async mounted() {
      if (this.data) {
        Object.keys(this.data).forEach(key => {
          this.address[key] = this.data[key]
        })
        if (this.data.streetName) {
          this.localStreetName = this.data.streetName
        }
        if (this.data.city) {
          const response = await this.$store.dispatch('cities/fetchByName', this.data.city)
          if (OK === response.status) {
            this.localCity = this.data.city
            const city = response.data
            this.counties = kvpsForSelectFromArray(city.counties)
            this.zipCodes = kvpsForSelectFromArray(city.zipCodes)
          }
        }
      }
      this.$store.commit('address/cities', [])
      this.$store.commit('address/streets', [])
      this.$eventHub.$on('citySaved', this.setCityLoadCountiesZips)
      this.$eventHub.$on('noCitySaved', this.clearCity)
      this.$eventHub.$on('streetSaved', this.setStreet)
      this.$eventHub.$on('noStreetSaved', this.clearStreet)
    },
    destroyed() {
      this.$eventHub.$off('citySaved')
      this.$eventHub.$off('noCitySaved')
      this.$eventHub.$off('streetSaved')
      this.$eventHub.$off('noStreetSaved')
    },
    watch: {
      localCity: {
        handler: function(localCity) {
          if (!localCity) {
            this.resetDependentAutocompleteFields()
          }
        }
      },
      localStreetName: {
        handler: function(localStreetName) {
          if (!localStreetName) {
            this.address.streetName = null
          }
        }
      }
    }
  }
</script>
